<template>
  <transition appear name="fade">
    <div id="upgrade-loading" class="dialog">
      <div class="content">
        <div class="title">
          <div class="image-wrap">
            <bubble-tea v-if="!isFinish" class="svg"></bubble-tea>
            <img v-else src="@/assets/images/icon-pass.png" alt="" />
          </div>
          <p class="text">
            {{ text }}
          </p>
        </div>
        <cus-progress :progress="progress" :textColor="'#fff'"></cus-progress>
      </div>
    </div>
  </transition>
</template>
<script>
import { ref, defineAsyncComponent, watch } from 'vue';
import { useUpgradeLoading, doSetCheckInterval, clearCheckInterval } from '@/utils/upgrade';
import store from '@/store';
export default {
  name: 'upgrade-loading',
  components: {
    CusProgress: defineAsyncComponent(() => import('@/library/CusProgress.vue')),
    BubbleTea: defineAsyncComponent(() => import('@/library/BubbleTea.vue')),
  },
  setup() {
    //設定進度條
    const progress = ref(0);
    const isFinish = ref(false);
    const text = ref('軟體更新中...');
    let timer;
    timer = setInterval(() => {
      progress.value += 1;
    }, 1000);
    watch(progress, () => {
      if (progress.value === 90) {
        clearInterval(timer);
      }
    });
    doSetCheckInterval(7000);
    //關閉視窗
    const handleClose = () => {
      clearInterval(timer);
      clearCheckInterval();
      useUpgradeLoading(false);
    };
    //更新結束
    watch(
      () => store.getters['upgrade/getSoftwareStatus'],
      () => {
        if (store.getters['upgrade/getSoftwareStatus'] === 4) return;
        else if (store.getters['upgrade/getSoftwareStatus'] === 0) {
          text.value = '軟體已更新完成！';
          progress.value = 100;
          isFinish.value = true;
          setTimeout(() => {
            window.location.reload();
            handleClose();
          }, 3000);
        } else {
          handleClose();
        }
      }
    );
    return { progress, isFinish, text };
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  @include flex-center-center;
  width: 100%;
  height: 100%;
  background-color: $color-mask;
  position: fixed;
  top: 0;
  z-index: 999;
  .title {
    @include flex-center-center;
    margin-bottom: 20px;
    .image-wrap {
      @include flex-center-center;
      margin-right: 15px;
      width: 50px;
      height: 60px;
      .svg {
        animation: shake 3.5s linear infinite 0.2s;
      }
      img {
        width: 100%;
      }
    }
    .text {
      font-size: 2.2rem;
      color: #fff;
      text-align: center;
    }
  }
  .content {
    width: 40%;
  }
}

@keyframes shake {
  0% {
    transform: rotate(-5deg);
  }
  5% {
    transform: rotate(10deg);
  }
  10% {
    transform: rotate(-5deg);
  }
  15% {
    transform: rotate(10deg);
  }
  20% {
    transform: rotate(-5deg);
  }
  25% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
